import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { activateTenant, suspendTenant } from '@/api/tenants/tenantsApi';
import type { Tenant } from '@/api/tenants/tenantsApi.types';
import { TENANTS_QUERY_KEY, buildTenantQueryKey } from '@/constants/queryKeys';

function useTenantStatusMutation(
  changeStatus: (tenantId: string) => Promise<Tenant>
): UseMutationResult<Tenant, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changeStatus,
    onSuccess: function invalidateAffectedQueries(_tenant, tenantId) {
      queryClient.invalidateQueries({ queryKey: buildTenantQueryKey(tenantId) });
      queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
    },
  });
}

export function useSuspendTenantMutation(): UseMutationResult<Tenant, Error, string> {
  return useTenantStatusMutation(suspendTenant);
}

export function useActivateTenantMutation(): UseMutationResult<Tenant, Error, string> {
  return useTenantStatusMutation(activateTenant);
}
